// Brand + contact configuration is sourced from content JSON (src/data/content/site.json).
// This file only holds the small helpers (logic), not the content itself.
import site from "@/data/content/site.json";

export const BRAND = site.brand;

const DEFAULT_MSG = site.defaultEnquiry;

export function whatsappLink(message = DEFAULT_MSG) {
  return `https://wa.me/${BRAND.whatsappRaw}?text=${encodeURIComponent(message)}`;
}

export function bookingLink(propertyName) {
  const msg = `Hi IndiAbode! I'd like to book "${propertyName}" in Varanasi. Could you share availability and pricing?`;
  return whatsappLink(msg);
}

export const NAV_LINKS = site.nav;
